export interface ApiSuccess<T> {
  ok: true;
  message: string;
  data: T;
}

export interface ApiFailure {
  ok: false;
  message: string;
  error: { code: string; message: string; details?: unknown };
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

const DEFAULT_API_BASE = import.meta.env.PROD
  ? "https://uinus-form.com/better-table-api/api"
  : "/api";
const API_BASE = (import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE).replace(/\/$/, "");

export function apiUrl(path: string) {
  return `${API_BASE}${path}`;
}

export async function requestApi<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (!(init?.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const response = await fetch(apiUrl(path), {
    ...init,
    headers,
  });
  const raw = await response.text();
  let payload: ApiResponse<T>;
  try {
    payload = JSON.parse(raw) as ApiResponse<T>;
  } catch {
    throw new Error(response.ok ? "서버 응답을 확인할 수 없습니다." : "요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.");
  }
  if (!response.ok || !payload.ok) throw new Error(payload.message || "요청을 처리할 수 없습니다.");
  return payload.data;
}
